import { render } from "./FollowButton.vue?vue&type=template&id=32f2382e&lang=pug"
import script from "./FollowButton.vue?vue&type=script&lang=js"
export * from "./FollowButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__